module.exports = __webpack_public_path__ + "static/demo2-c5a206f5725b3e68b5a8e1279314a638.png";